// Client-side checks for new schedule templates. They mirror createScheduleTemplate in
// backend/src/controllers/indicator.controller.js, where every offset counts in days after the
// period end: approval on or after submission, lock on or after approval, integer offsets,
// non-negative reminder. The backend remains the authority and rejects the same input.
export function scheduleTemplateValidation(f) {
    const integer = value => value === "" || value == null ? null : (Number.isInteger(Number(value)) ? Number(value) : NaN);
    if (!String(f.label || "").trim() || !f.frequency) return "Template name and frequency are required.";
    const submit = integer(f.submitAfterDays), approve = integer(f.approveAfterDays), lock = integer(f.lockAfterDays);
    const open = integer(f.openOffsetDays), reminder = integer(f.reminderDays);
    if (submit == null || approve == null || lock == null) return "Submission, approval and lock days are required.";
    if ([submit, approve, lock, open, reminder].some(value => Number.isNaN(value))) return "Day offsets must be whole numbers.";
    if (reminder != null && reminder < 0) return "Reminder days cannot be negative.";
    if (approve < submit) return "The approval deadline must be on or after the submission deadline.";
    if (lock < approve) return "Lock date must be after the approval deadline.";
    return null;
}

// Schedule offsets are all relative to the occurrence/period end, not to each
// other. Keep this pure so the frontend calendar and backend contract can be
// regression-tested without a database or browser.
export function approvalDeadlineFromPeriodEnd(periodEnd, approveAfterDays, addDays) {
    return addDays(periodEnd, approveAfterDays);
}
